import {
    HeaderMenu,
    Card,
    DateInput,
    BaseTable,
    TableSection,
    NumberInput,
    TableHeader,
    Button,
    Loading,
    Select,
    AccountModal
} from "components"
import { useBillDetail } from "./utils/useBillDetail"; 
import { useAccountCode } from "./utils/useAccountCode";
import { adjustmentFreightStore } from "./utils/adjustmentFreightStore"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { convertNumber, getStatusLabel, useApi, useToggle } from "utils";
import moment from "moment";
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { adjustmentFreightSchema } from './validation/adjustmentFreightSchema';
import { FormState } from "./types/billAdjustmentTypes";
import toast from "react-hot-toast";
import { CodeAdjustmentFreight } from "./components/CodeAdjustmentFreight";
import { PropsValue } from "react-select"

export default function CreateBillAdjustment(){
    const navigate = useNavigate()
    const { isActive, toggle } = useToggle(false)
    const [isDebet, setDebet] = useState(false);
    const api = useApi();
    const params = useParams()
    const bill_id = params.id!
    const { fetchData } = useBillDetail(bill_id)
    const { accountData:accountDebet } = useAccountCode('LA07')
    const { accountData:accountCredit } = useAccountCode('BA01')

    const {
        isLoading,
        data_bill,
        total_detail,
        saldo,
        adj_code,
        setDataFrom,
        reset,
    } = adjustmentFreightStore()

    const methods = useForm<FormState>({
        resolver: yupResolver(adjustmentFreightSchema),
        defaultValues: {
          bill_id: Number(bill_id),
          transaction_date: moment().format("YYYY-MM-DD"),
          adj_freight: 0,
          saldo_freight: 0,
          coa_ap_debet: 0,
          coa_ap_debet_name: '',
          coa_freight_credit: 0,
          coa_freight_credit_name: '',
          location_id: 0,
          employee_id: 0,
          vendor_id:0,
        },
      });
      
      const { handleSubmit, control, watch, setValue, reset: resetForm } = methods;
      const resetStore = reset;
      

      useEffect(() => {
        const init = async () => {
           // Reset Zustand store
            resetStore();
        
            // Reset form React Hook Form 
            resetForm({
                bill_id: Number(bill_id),
                transaction_date: moment().format("YYYY-MM-DD"),
                adj_freight: 0,
                saldo_freight: 0,
                coa_ap_debet: 0,
                coa_freight_credit: 0,
                coa_ap_debet_name: '',
                coa_freight_credit_name: '',
                location_id: 0,
                employee_id: 0,
                vendor_id:0,
            });
        
            // Fetch data 
            await fetchData();
        
          };
          init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

    //setvalue ke form data
    useEffect(() => {
        setDataFrom({
            coa_ap_debet:accountDebet?.coa_id,
            coa_ap_debet_name:`${accountDebet?.coa_code} - ${accountDebet?.coa_name}`,
            coa_freight_credit:accountCredit?.coa_id,
            coa_freight_credit_name:`${accountCredit?.coa_code} - ${accountCredit?.coa_name}`
        })
        setValue("bill_id", Number(bill_id))
        setValue("coa_ap_debet", Number(accountDebet?.coa_id));
        setValue("coa_freight_credit", Number(accountCredit?.coa_id));
        setValue("coa_ap_debet_name", String(`${accountDebet?.coa_code} - ${accountDebet?.coa_name}`));
        setValue("coa_freight_credit_name", String(`${accountCredit?.coa_code} - ${accountCredit?.coa_name}`));
        setValue("location_id", Number(data_bill.location_id));
        setValue("employee_id", Number(data_bill.employee_id));
        setValue("vendor_id", Number(data_bill.vendor_id));
        // eslint-disable-next-line
    }, [accountDebet,accountCredit, setValue])

    //wath perubahan adj
    const adjustmentFreight = watch("adj_freight");
    useEffect(() => {
        const newSaldo = Number(data_bill.freight) - Number(adjustmentFreight || 0);
        setValue("saldo_freight", newSaldo);
        setDataFrom({adj_freight:adjustmentFreight})
    }, [adjustmentFreight, data_bill.freight, setValue,setDataFrom]);

    const onSubmit = (value: FormState) => {
    
        return new Promise<void>((resolve) => {
         
            toast.promise(
                api.post("/probill/save_adj_freight", value),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.detail?.message ?? err.response.data.message
                }
            ).then(() => {
                reset();
                navigate("/purchase/transaction/adjustment-freight/list", { replace: true })
            }).catch(() => { }).finally(resolve)
      
        })
    }


    // handle semua error
    const onError = (errors: any) => {
        Object.values(errors).forEach((error: any) => {
            if (error?.message) {
                toast.error(error.message)
            } else if (typeof error === 'object') {
                Object.values(error).forEach((subError: any) => {
                    if (subError?.message) toast.error(subError.message)
                })
            }
        })
    };
    
    
    if (isLoading) return ( <Loading
        loading={isLoading}
        errorText="No data available"
    />)
    
    return(
        <section className="mx-3">
            <section className="mt-1">
                <HeaderMenu title="ADJUSTMENT FREIGHT - BILL">
                    <CodeAdjustmentFreight/>
                </HeaderMenu>
            </section>

            <section className="overflow-x-auto max-h-[calc(100vh-300px)] m-0 p-0">
                <section>
                    <Card>
                        <Card.Body>
                            <section className="grid lg:grid-cols-2 gap-x-6 gap-y-1">
                                <div className="flex flex-col">
                                    <TableSection textLeft>

                                        <TableSection.Row
                                            className="uppercase"
                                            label="BILL ID#"
                                            value={data_bill.trx_code}
                                        />

                                        <TableSection.Row
                                            className="uppercase"
                                            label="DATE"
                                            value={moment(data_bill.transaction_date).format('DD/MM/YYYY')}
                                        />

                                        <TableSection.Row
                                            className="uppercase"
                                            label="SO ID#"
                                            value={data_bill.po_code}
                                        />
                                    
                                    </TableSection>
                                </div>

                                <div className="flex flex-col lg:items-end min-w-[400px]">
                                    <section className="w-full min-w-[100px] md:max-w-[400px]">
                                    <TableSection textLeft={false}>

                                        <TableSection.Row
                                            className="uppercase"
                                            label="VENDOR"
                                            value={data_bill.vendor_name}
                                        />

                                        <TableSection.Row
                                            className="uppercase"
                                            label="STATUS"
                                            value={getStatusLabel(String(data_bill.bill_status))}
                                        />

                                    </TableSection>
                                    </section>
                                    
                                </div>
                            </section>
                        </Card.Body>
                    </Card>
                </section>

                <section>
                    <Card>
                        <Card.Body>
                            <section className="grid lg:grid-cols-2 gap-x-6">
                                <div className="flex flex-col">
                                    <BaseTable
                                        plain
                                        className="w-full min-w-[100px] md:max-w-[400px]"
                                    >
                                        <tbody>
                                            <tr>
                                                <td className="w-[1px] whitespace-nowrap">FREIGHT</td>
                                                <td className="text-right">{convertNumber(Number(data_bill.freight)).intoCurrency}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-[1px] whitespace-nowrap">ITEM DETAIL</td>
                                                <td className="text-right">{convertNumber(Number(data_bill.total_bill)).intoCurrency}</td>
                                            </tr>
                                            <tr>
                                                <td className="w-[1px] whitespace-nowrap">TAX</td>
                                                <td className="text-right">{convertNumber(Number(data_bill.total_tax)).intoCurrency}</td>
                                            </tr>
                                            <tr className="border-t-2 border-black text-lg font-bold">
                                                <td className="w-[1px] whitespace-nowrap"></td>
                                                <td className="text-right">{convertNumber(total_detail).intoCurrency}</td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr className="text-error">
                                                <td className="w-[1px] whitespace-nowrap">REFUND</td>
                                                <td className="text-right">{convertNumber(Number(data_bill.tot_payment)).intoCurrency}</td>
                                            </tr>
                                            <tr className="border-t-2 border-black text-lg font-bold">
                                                <td className="w-[1px] whitespace-nowrap"></td>
                                                <td className="text-right">{convertNumber(saldo).intoCurrency}</td>
                                            </tr>
                                        </tbody>
                                    </BaseTable>
                                </div>
                                <div className="flex flex-col w-full items-end">  
                                    <BaseTable
                                        plain
                                        className="w-full"
                                    >
                                        <tbody>
                                            <tr className="flex items-center">
                                                <td className="text-right w-full">DATE</td>
                                                <td className="text-center">:</td>
                                                <td className="justify-end min-w-[200px]">
                                                    <Controller
                                                        name="transaction_date"
                                                        control={control}
                                                        render={({ field }) => (
                                                        <DateInput
                                                            selected={moment(field.value).toDate()}
                                                            onChange={(date) =>
                                                                field.onChange(moment(date).format("YYYY-MM-DD"))
                                                            }
                                                        />
                                                        )}
                                                    />
                                                </td>
                                            </tr>
                                            <tr className="flex items-center">
                                                <td className="text-right w-full">ADJUSTMENT FREIGHT</td>
                                                <td className="text-center">:</td>
                                                <td className="justify-end min-w-[200px]">
                                                    <Controller
                                                        name="adj_freight"
                                                        control={control}
                                                        render={({ field, fieldState  }) => (
                                                            <NumberInput
                                                                textRight={true}
                                                                value={field.value}
                                                                onValueChange={(value) => {
                                                                    if (value?.floatValue == null || isNaN(value.floatValue)) {
                                                                        field.onChange(0)
                                                                    } else {
                                                                        field.onChange(value.floatValue)
                                                                    }
                                                                }}
                                                                error={fieldState.error?.message}
                                                            />
                                                        )}
                                                    />
                                                </td>
                                            </tr>
                                            <tr className="flex items-center">
                                                <td className="text-right w-full">SALDO FREIGHT</td>
                                                <td className="text-center">:</td>
                                                <td className="justify-end min-w-[200px]">
                                                    <Controller
                                                        name="saldo_freight"
                                                        control={control}
                                                        render={({ field }) => (
                                                        <NumberInput readOnly={true} textRight={true} value={field.value??0} />
                                                        )}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </BaseTable>
                                </div>
                            </section>
                            <section className="w-full mt-5">
                                <div>
                                    JOURNAL
                                </div>
                                <BaseTable className="w-full">
                                    <TableHeader>
                                        <th>DATE</th>
                                        <th>IDM</th>
                                        <th>ACCOUNT</th>
                                        <th>DEBET</th>
                                        <th>CREDIT</th>
                                    </TableHeader>
                                    <tbody>
                                        <tr>
                                            <td>{watch('transaction_date')}</td>
                                            <td>{adj_code}</td>
                                            {/* <td>{`${accountDebet?.coa_code} - ${accountDebet?.coa_name}`}</td> */}
                                            <td>
                                                <Controller
                                                    control={control}
                                                    name="coa_ap_debet"
                                                    render={({ field, fieldState }) => {
                                                    let value: PropsValue<{
                                                        value: string
                                                        label: string
                                                    }> = null
                                                    let coa_name = watch('coa_ap_debet_name')??'-';
                                                    
                                                    if (field.value && coa_name) {
                                                        value = {
                                                            label: coa_name,
                                                            value: String(field.value)
                                                        }
                                                    }

                                                    return (
                                                        <section onClick={()=>{
                                                            toggle()
                                                            setDebet(true)
                                                        }}>
                                                            <Select
                                                                placeholder="Select Account"
                                                                error={fieldState.error?.message}
                                                                ref={field.ref}
                                                                value={value}
                                                            />
                                                            </section>
                                                        )
                                                    }}
                                                />
                                            </td>
                                            <td className="text-end">{convertNumber(adjustmentFreight).intoCurrency}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>{watch('transaction_date')}</td>
                                            <td>{adj_code}</td>
                                            <td>
                                                <Controller
                                                    control={control}
                                                    name="coa_freight_credit"
                                                    render={({ field, fieldState }) => {
                                                    let value: PropsValue<{
                                                        value: string
                                                        label: string
                                                    }> = null
                                                    let coa_name = watch('coa_freight_credit_name')??'-';
                                                    
                                                    if (field.value && coa_name) {
                                                        value = {
                                                            label: coa_name,
                                                            value: String(field.value)
                                                        }
                                                    }

                                                    return (
                                                        <section onClick={()=>{
                                                            toggle()
                                                            setDebet(false)
                                                        }}>
                                                            <Select
                                                                placeholder="Select Account"
                                                                error={fieldState.error?.message}
                                                                ref={field.ref}
                                                                value={value}
                                                            />
                                                            </section>
                                                        )
                                                    }}
                                                />
                                            </td>
                                            <td></td>
                                            <td className="text-end">{convertNumber(adjustmentFreight).intoCurrency}</td>
                                        </tr>
                                    </tbody>
                                </BaseTable>
                            </section>

                            <section>
                                <TableSection textLeft>

                                    <TableSection.Row
                                        className="uppercase"
                                        label="EMPLOYEE"
                                        value={String(data_bill.employee_name)}
                                    />

                                    <TableSection.Row
                                        className="uppercase"
                                        label="LOCATION"
                                        value={String(data_bill.location_name)}
                                    />
                                </TableSection>
                            </section>

                            <section className="w-full flex justify-end mb-5">
                                <Button color="primary" 
                                    type="button"
                                    permission="ST19"
                                    onClick={handleSubmit(onSubmit, onError)}
                                >
                                    ADJUSTMENT
                                </Button>
                            </section>
                        </Card.Body>
                    </Card>
                </section>
            </section>

            {isActive && (
                <AccountModal
                    defaultGroup="01"
                    toggle={toggle}
                    onChange={(value, label, coa) => {     
                        if(isDebet) {
                            setValue('coa_ap_debet',Number(value))
                            setValue('coa_ap_debet_name',label)
                        }else{
                            setValue('coa_freight_credit',Number(value))
                            setValue('coa_freight_credit_name',label)
                        }
                    }}
                />
            )}

            
        </section>
    )
}